import { DATA_GRID_LAZY_PAGE_SIZE } from '@/components/DataGrid/definitions';
import { useDataGridFetcher } from '@/hooks/api/useDataGridFetcher';
import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';

export const LIST_REPORTS_QUERY_KEY = 'reports.listReports';

export const getListReportsQueryKey = ({
  page,
  perPage,
  tenantId,
}: {
  page?: string | number;
  perPage?: string | number;
  tenantId?: string;
} = {}) => [
  LIST_REPORTS_QUERY_KEY,
  {
    tenantId,
    page: +(page ?? 1),
    perPage: +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
  },
];

const queryFunction =
  ({ page, perPage, tenantId }: { page?: string | number; perPage?: string | number; tenantId?: string } = {}) =>
  () => {
    return api.reports.listReports({
      tenantId: tenantId ?? '',
      page: +(page ?? 1),
      perPage: +(perPage ?? DATA_GRID_LAZY_PAGE_SIZE),
    });
  };

export const useFetchListReports = () => {
  const { getTenantId } = useTenants();
  return useDataGridFetcher({
    queryKey: parameters => getListReportsQueryKey({ tenantId: getTenantId(), ...parameters }),
    queryFn: parameters => queryFunction({ tenantId: getTenantId(), ...parameters }),
  });
};
